import React from 'react';
import { motion } from 'framer-motion';
import { WaitlistForm } from './WaitlistForm';
import { Shield, Lock, CheckCircle2 } from 'lucide-react';
interface FinalCTAProps {
  onSignup?: (email: string) => void;
}
export function FinalCTA({
  onSignup
}: FinalCTAProps) {
  return <section id="join" className="py-24 bg-slate-900 relative overflow-hidden" data-id="element-38">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-blue-500/10 rounded-full blur-[120px] pointer-events-none" data-id="element-39" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-40">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-4xl md:text-5xl font-display font-bold text-white mb-6" data-id="element-41">
          Ready to Fill Seats Faster?
        </motion.h2>
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-xl text-slate-400 mb-10" data-id="element-42">
          Join the waitlist and be first to automate your driver hiring.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="mb-12" data-id="element-43">
          <WaitlistForm buttonSize="large" onSignup={onSignup} data-id="element-44" />
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="flex flex-wrap items-center justify-center gap-8 text-slate-400" data-id="element-45">
          <div className="flex items-center gap-2" data-id="element-46">
            <Shield className="w-5 h-5 text-slate-500" data-id="element-47" />
            <span className="text-sm font-medium" data-id="element-48">SOC 2 Certified</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-49">
            <CheckCircle2 className="w-5 h-5 text-slate-500" data-id="element-50" />
            <span className="text-sm font-medium" data-id="element-51">FMCSA Compliant</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-52">
            <Lock className="w-5 h-5 text-slate-500" data-id="element-53" />
            <span className="text-sm font-medium" data-id="element-54">256-bit Encryption</span>
          </div>
        </motion.div>
      </div>
    </section>;
}